(function () {
  "use strict";

  angular.module("sempraWebapp").component("multiplyItemsSelector", {
    templateUrl:
      "app/components/multiplyItemsSelector/multiplyItemsSelector.html",
    controller: multiplyItemsSelectorController,
    bindings: {
      list: "<",
      enableSelector: "<",
      clearSiteTextInput: "<",
      placeHolderText: '<',
      selectedItem: "<",
      disableSelector: "<",
      selectedList: "&",
      validateInput: "&"
    },
    controllerAs: "vm"
  });

  function multiplyItemsSelectorController($translate, $scope, $element) {
    var vm = this;

    vm.searchTerm = "";
    vm.selectedItem = "";
    $element.find("input").on("keydown", function (ev) {
      ev.stopPropagation();
    });

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.list) {
        vm.datas = changes.list.currentValue;
        if(changes.list.currentValue.length === 0) {
          vm.validateInput({valid: false});
        }
      }
      if (changes.clearSiteTextInput) {
        if (changes.clearSiteTextInput.currentValue === "") {
          vm.selectedItem = "";
          vm.searchTerm = "";
          vm.validateInput({valid: false});
        } else {
          vm.validateInput({valid: true});
        }
      }
    };

    vm.$onDestroy = function () {};
  }
})();
